module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073fc_banner_800x600.39ef1d98.png";